<section class="eco-chg" aria-label="O que mudou">
  <div class="eco-chg__head">
    <div class="eco-chg__lead">
      <p class="eco-chg__eyebrow">O que mudou</p>
      <p class="eco-chg__sentence">
        @if (summary().direction === 'flat') {
          A economia <b>não mudou</b>
        } @else {
          A economia {{ summary().direction === 'up' ? 'subiu' : 'caiu' }}
          <b [ngClass]="signClass(measure().variation)"
            >R$&nbsp;{{ summary().amount | vaultFormatCurrency: 2 }}</b
          >
          {{ percentLabel() }}
        }
        de {{ startDate() ? (startDate() | vaultDate) : 'início' }} para
        {{ endDate() ? (endDate() | vaultDate) : 'hoje' }}, <b>{{ sentenceTail() }}</b
        >.
      </p>
    </div>
    <div class="eco-chg__tiles">
      <div class="eco-chg__tile">
        <span class="eco-chg__tile-label">{{
          startDate() ? (startDate() | vaultDate) : 'Início'
        }}</span>
        <span class="eco-chg__tile-value"
          >R$&nbsp;{{ measure().start | vaultFormatCurrency: 2 }}</span
        >
      </div>
      <i class="pi pi-arrow-right eco-chg__arrow" aria-hidden="true"></i>
      <div class="eco-chg__tile">
        <span class="eco-chg__tile-label">{{ endDate() ? (endDate() | vaultDate) : 'Fim' }}</span>
        <span class="eco-chg__tile-value"
          >R$&nbsp;{{ measure().end | vaultFormatCurrency: 2 }}</span
        >
      </div>
    </div>
  </div>

  <!-- Abas do design system (app-tab-view só como cabeçalho; o conteúdo troca pelo índice). -->
  <div class="eco-chg__tabs">
    <app-tab-view
      [tabViewItems]="tabItems()"
      [tabIndex]="tab() === 'reason' ? 0 : 1"
      theme="line"
      (sendTabViewActiveIndex)="onTabChange($event)"></app-tab-view>
  </div>

  @if (tab() === 'reason') {
    @if (items().length) {
      <ul class="eco-chg__items">
        @for (item of items(); track item.category) {
          <li class="eco-chg__item" [class.is-open]="isExpanded(item)">
            <button
              type="button"
              class="eco-chg__item-head"
              [disabled]="!canExpand(item)"
              [attr.aria-expanded]="isExpanded(item)"
              (click)="toggle(item)">
              <i
                class="pi eco-chg__chevron"
                [class.pi-chevron-right]="!isExpanded(item)"
                [class.pi-chevron-down]="isExpanded(item)"
                [class.is-hidden]="!canExpand(item)"
                aria-hidden="true"></i>
              <span class="eco-chg__item-text">
                <span class="eco-chg__item-label">{{ categoryLabels[item.category] }}</span>
                <span class="eco-chg__item-hint">{{ categoryHints[item.category] }}</span>
              </span>
              <span class="eco-chg__bar" aria-hidden="true">
                <span
                  class="eco-chg__bar-fill"
                  [ngClass]="signClass(item.value)"
                  [style.width.%]="barWidth(item)"></span>
              </span>
              <span class="eco-chg__item-value" [ngClass]="signClass(item.value)">
                R$&nbsp;{{ item.value | vaultFormatCurrency: 2 }}
              </span>
            </button>

            @if (isExpanded(item)) {
              <div class="eco-chg__detail">
                @if (item.events.length) {
                  <div class="eco-chg__detail-block">
                    <span class="eco-chg__detail-title">Eventos</span>
                    @for (ev of item.events; track ev.generatedAt + ev.companyId) {
                      <div class="eco-chg__event">
                        <span class="eco-chg__event-when">{{
                          ev.generatedAt | vaultDateTime
                        }}</span>
                        <span class="eco-chg__event-what">
                          {{ triggerLabel(ev.trigger) }}
                          @if (ev.triggerDetail) {
                            · {{ ev.triggerDetail }}
                          }
                          @if (ev.triggeredByName) {
                            · por {{ ev.triggeredByName }}
                          }
                        </span>
                        <span class="eco-chg__event-value" [ngClass]="signClass(ev.value)">
                          R$&nbsp;{{ ev.value | vaultFormatCurrency: 2 }}
                        </span>
                      </div>
                    }
                  </div>
                }
                @if (item.loans.length) {
                  <div class="eco-chg__detail-block">
                    <span class="eco-chg__detail-title">Operações</span>
                    <div class="eco-chg__loans">
                      @for (loan of item.loans; track loan.loanOperationId) {
                        <button
                          type="button"
                          class="eco-chg__loan"
                          (click)="loanSelected.emit(loan.loanOperationId)">
                          <span class="eco-chg__loan-code">
                            {{ loan.sequentialId || 'Operação' }}
                            @if (companyNames()[loan.companyId]; as name) {
                              <span class="eco-chg__loan-company">· {{ name }}</span>
                            }
                          </span>
                          <span class="eco-chg__event-value" [ngClass]="signClass(loan.value)">
                            R$&nbsp;{{ loan.value | vaultFormatCurrency: 2 }}
                          </span>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </li>
        }
      </ul>
    }

    @if (unchanged().length) {
      <p class="eco-chg__unchanged">
        <i class="pi pi-check" aria-hidden="true"></i>
        <span>Sem mudança no período:</span>
        @for (category of unchanged(); track category) {
          <span class="eco-chg__chip" [title]="categoryHints[category]">{{
            categoryLabels[category]
          }}</span>
        }
      </p>
    }
  } @else {
    <app-economy-operations-changes
      [operations]="operations()"
      [companyNames]="companyNames()"
      [startDate]="startDate()"
      [endDate]="endDate()"
      (loanSelected)="loanSelected.emit($event)"></app-economy-operations-changes>
  }

  @if (measureKey() === 'inicial') {
    <p class="eco-chg__note">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      A Prevista Inicial usa o DI da primeira foto de cada operação: sem evento, ela não muda.
    </p>
  }
</section>
